import React, { useState } from 'react';

import DomainHistory from '../../components/domainHistory.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'

import {HistoryPageResult} from '../../../../server/routes/website.js'

interface WebsiteHistoryProps {
    server: string,
    pageData: unknown
}

export default function WebsiteHistory({ server, pageData }: WebsiteHistoryProps) {

	let [data, setData] = useState(pageData as HistoryPageResult);

    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
                <DomainHistory 
                    technologyChanges={data.TechnologyChanges}
                />    
            </div>
        </section>
    </>)
}